export default "__VITE_ASSET__D2f4YwU2__"